export class AppBaseException {
    constructor(private error: string) {}
}
